<template>

    <div class="sidebar">

        <div id="views-tabs" class="full-height">

            <div class="view-tabs-list">

                <ViewTab @newActiveTab="newActiveTab" v-for="productConfigurationView in productConfigurationViews" :product-configuration-view="productConfigurationView"></ViewTab>

            </div>

            <div v-if="!disableCreating" class="option-button">

                <div class="select">

                    <select v-model="viewIdAsBlueprint">
                        <option value="null" disabled="disabled">Wähle einen Aufdruck...</option>
                        <option v-for="view in createableProductViews" :value="view.id">{{view.title}}</option>
                    </select>

                </div>

            </div>

            <div v-if="!disableCreating" class="option-button">

                <a @click="$emit('createNewProductConfigurationView', viewIdAsBlueprint)" class="btn btn-fullsize">Aufdruck hinzufügen</a>

            </div>

        </div>

    </div>
    
</template>

<script>
    import ViewTab from "./ViewTab";
    import moduleLoader from "../loader/Loader";

    export default {
        name: "ViewTabList",
        components: {
            ViewTab: () => moduleLoader.loadModule('ViewTab')
        },
        data: () => ({
            viewIdAsBlueprint: null
        }),
        props: {
            createableProductViews: {
                type: Array,
                default: () => ([])
            },
            productConfigurationViews: {
                type: Array,
                default: () => ([])
            },
            disableCreating: {
                type: Boolean,
                default: false
            }
        },
        methods: {

            newActiveTab(id) {
                window.EventHandler.$emit('clearobjectview');
                this.$emit('newActiveTab', id);
            }

        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";
    @import "~@/assets/scss/fonts";

    #views-tabs {
        flex-grow: 1;
        overflow: auto;
    }

    .full-height {
        height: 100%;
        display: flex;
        flex-direction: column;

        .option-button {
            flex-shrink: 0;
            flex-grow: 0;
        }

        .view-tabs-list {
            flex-grow: 1;
            flex-shrink: 1;
        }
    }

    .select {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid $grey-font;
        border-radius: 5px;
        position: relative;
        background-color: #ffffff;

        select {
            font-size: 0.8rem;
            border-radius: 5px;
            margin: 0;
            padding: 0.6rem 2rem 0.6rem 0.4rem;
            border: 0;
            box-sizing: border-box;
            width: 100%;
            -webkit-appearance: none;
            -moz-appearance: none;

            &::-ms-expand {
                display: none;
            }

            &:hover {
                cursor: pointer;
            }
        }

        &::after {
            position: absolute;
            font-family: "Material Icons";
            content: "arrow_drop_down";
            top: 50%;
            margin-top: -.5rem;
            right: .5rem;
            width: 1rem;
            height: 1rem;
            color: $blue-color;
            font-size: 1rem;
        }
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        box-sizing: border-box;
        background: $blue-color;
        color: #ffffff;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 5px;

        &:hover {
            cursor: pointer;
        }
    }

    .btn-fullsize {
        height: 100%;
        width: 100%;
    }

</style>